// extracted by mini-css-extract-plugin
export default {"btn":"OrderSheet_btn__Mqf5G","buttons":"OrderSheet_buttons__jgqTc"};